import i18n from 'i18next';
import { initReactI18next } from 'react-i18next';

import messagesPL from './locale/messages.pl.json';
import messagesEN from './locale/messages.en.json';

const resources = {
  en: {
    translation: messagesEN
  },
  pl: {
    translation: messagesPL
  }
};

i18n
  .use(initReactI18next)
  .init({
    resources,
    lng: 'pl',

    keySeparator: false,
    interpolation: {
      escapeValue: false
    }
  });

export default i18n;
